import { defineComponent as _defineComponent } from 'vue';
import { useFrameStore } from './seg-frame-store';
import { TABS } from './helpers/frameConstants';
import ConfigSidebar from './ConfigSidebar.vue';
import VisualizerCanvas from './VisualizerCanvas.vue';
import SidebarFooter from './SidebarFooter.vue';
import PrintWrapper from "./print-page/PrintWrapper.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SEGFrameBuilder',
    props: {
        initialBrands: { type: Array, required: false },
        initialFeatureData: { type: null, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const store = useFrameStore();
        const __returned__ = { props, store, get TABS() { return TABS; }, ConfigSidebar, VisualizerCanvas, SidebarFooter, PrintWrapper };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
